

angular
.module('inkfinder')
.controller('AppointmentAddController', function AppointmentAddController(
  $state,
  Appointment,
  Messages,
  Payments,
  AppointmentAddFactory,
  moment,
  AlertMessages,
  MergeProjects,
  NOTIFICATIONS,
  Notification,
  Session,
  Participants,
  _,
  collectorWantsNotif
) {
  let vm = this;
  vm.data = AppointmentAddFactory.data;
  vm.session = Session;

  if (Object.keys(vm.data.appointment).length) {
    vm.data.appointment = {
      id: vm.data.appointment.id,
      previously_paid: false,
      deposit_required: true,
      artist: {}
    };
  }

  // Exposed Functions
  vm.saveAppointment = saveAppointment;

  // Defaults
  vm.accordions = {};
  vm.message = {
    content: null,
    private: false
  };
  vm.payment_form = {
    payment_datetime: moment().toDate(),
    is_tip: false
  };

  // Get Payment Types
  Payments.getTypes().then(function(types) {
    vm.payment_types = types;
  });

  /**
   * @name saveAppointment
   * @description Function to save the Appointment
   * @param {type} status description
   */
  function saveAppointment(status) {
    Appointment.update(vm.data.appointment, status).then(function(appointment) {
      // Create a participant for the artist, if one exists
      const conversationId = appointment.conversations;
      Participants.get(conversationId).then(function(participants) {
        let artistParticipant = _.find(participants, function(participant) {
          if (appointment.artist && participant.collector === appointment.artist.id) {
            return true;
          }
        });
        if (!artistParticipant && appointment.artist) {
          let preparedParticipant = {
            role: Session.activeState.role,
            conversation_id: conversationId,
            collector_id: appointment.artist.id,
            appointment_id: appointment.id
          };
          Participants.create(preparedParticipant);
        }
      });

      // Merge the project/appointment
      let appointmentArray = [];
      appointmentArray[0] = appointment;
      MergeProjects.merge(appointmentArray).then(function(mergedAppointment) {
        vm.data = mergedAppointment[0];

        // Send email notifications to artists and collectors
        // Check to see if we have the appropriate data on the appointment
        if ((vm.data.appointment.estimate_min &&
        vm.data.appointment.estimate_max ||
        vm.data.appointment.previously_paid) && vm.data.appointment.artist &&
        vm.data.appointment.appointment_datetime) {
          let notificationCollector = {};
          let notificationArtist = {};

          // If the appointment is unconfirmed, send the estimate notification
          if (vm.data.appointment.last_status.status_name === 'Unconfirmed') {
            // Collector notification
            notificationCollector = {
              recipients: [vm.data.project.collector.id],
              notificationId: NOTIFICATIONS.collectorEstimate,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The operator sending the estimate
                operatorId: Session.collector.id, // The operator sending the estimate
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.project.collector.first_name +
                ', ' + Session.collector.first_name + ' ' +
                Session.collector.last_name +
                ' sent you an estimate for your project on Ink Finder'
              }
            };

            // If the logged in user is an operator
            if (Session.activeState.association.shop.id) {
              notificationCollector.messageObjects.shopId =
              Session.activeState.association.shop.id;
              notificationCollector.messageVariables.subject =
              vm.data.project.collector.first_name +
              ', ' + Session.collector.first_name + ' ' +
              Session.collector.last_name + ' at ' +
              Session.activeState.association.shop.name +
              ' sent you an estimate for your project on Ink Finder';
            }

            // Artist notification
            notificationArtist = {
              recipients: [vm.data.appointment.artist.id],
              notificationId: NOTIFICATIONS.artistEstimate,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id,
                operatorId: Session.collector.id, // The operator sending the estimate
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.appointment.artist.first_name +
                ', ' + Session.collector.first_name + ' ' +
                Session.collector.last_name + ' at ' +
                Session.activeState.association.shop.name +
                ' sent an estimate for an appointment with ' +
                vm.data.project.collector.first_name + ' ' +
                vm.data.project.collector.last_name + ' on Ink Finder'
              }
            };

            if (Session.activeState.association.shop.id) {
              notificationArtist.messageObjects.shopId =
              Session.activeState.association.shop.id;
            }

            // Only send artist notifications if the artist isn't the one
            // creating the appointment and they want to receive the email
            collectorWantsNotif
            .check(appointment.artist.id, appointment.shop,
            'appointment_estimated', 'artist')
            .then(function(collectorWantsNotif) {
              if (Session.collector.id !==
              vm.data.appointment.artist.id && collectorWantsNotif) {
                Notification.send(notificationArtist);
              }
            });

          // If the appointment is confirmed, send the confirmed notification
          } else if (vm.data.appointment.last_status.status_name ===
          'Confirmed') {
            // Collector notification
            notificationCollector = {
              recipients: [vm.data.project.collector.id],
              notificationId:
              NOTIFICATIONS.appointmentConfirmedByOperatorOrArtist,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The collector who owns the project
                operatorId: Session.collector.id, // The logged in operator or artist
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.project.collector.first_name +
                ', ' + Session.collector.first_name + ' ' +
                Session.collector.last_name +
                ' confirmed an appointment for your project on Ink Finder'
              }
            };

            // If the logged in user is an operator
            if (Session.activeState.association.shop.id) {
              notificationCollector.messageObjects.shopId =
              Session.activeState.association.shop.id;
              notificationCollector.messageVariables.subject =
              vm.data.project.collector.first_name +
              ', ' + Session.collector.first_name + ' ' +
              Session.collector.last_name + ' at ' +
              Session.activeState.association.shop.name +
              ' confirmed an appointment for your project on Ink Finder';
            }

            // Artist notification
            notificationArtist = {
              recipients: [vm.data.appointment.artist.id],
              notificationId: NOTIFICATIONS.artistConfirmed,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The collector who owns the project
                operatorId: Session.collector.id, // The operator updating the appointment
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.appointment.artist.first_name +
                ', ' + Session.collector.first_name + ' ' +
                Session.collector.last_name + ' at ' +
                Session.activeState.association.shop.name +
                ' confirmed your appointment with ' +
                vm.data.project.collector.first_name + ' ' +
                vm.data.project.collector.last_name + ' on Ink Finder'
              }
            };

            if (Session.activeState.association.shop.id) {
              notificationArtist.messageObjects.shopId =
              Session.activeState.association.shop.id;
            }

            // Only send artist notifications if the artist isn't the one
            // creating the appointment and they want to receive the email
            collectorWantsNotif
            .check(appointment.artist.id, appointment.shop,
            'appointment_confirmed', 'artist')
            .then(function(collectorWantsNotif) {
              if (Session.collector.id !==
              vm.data.appointment.artist.id && collectorWantsNotif) {
                Notification.send(notificationArtist);
              }
            });
          }

          // Send the notification
          Notification.send(notificationCollector);
        }

        // If Payment Fields are filled out
        if (vm.accordions.payment && vm.payment_form.amount &&
        vm.payment_form.payment_type && vm.payment_form.payment_datetime) {
          vm.payment_form.status = 1;
          vm.payment_form.appointment_id = vm.data.appointment.id;
          vm.payment_form.collector_id = appointment.collector;
          Payments.create(vm.payment_form).then(function(response) {
            // Intentionally blank
          }, function(error) {
            AlertMessages.add({
              msg: 'We couldn’t save the payment right now, try adding it to the appointment later.',
              type: 'danger'
            });
          });
        }
        // Send a message to the shop team
        if (vm.message.content !== null &&
        vm.message.content.replace(/\s/g, '').length) {
          let message = {
            content: vm.message.content,
            cid: appointment.conversations,
            private: vm.message.private
          };
          Messages.create(message);
        }
        $state.go('inkfinder.appointments.add.complete');
      });
    }, function(response) {
      AlertMessages.add({
        msg: 'There was a problem updating this appointment.',
        type: 'danger'});
    });
  }
});



// WEBPACK FOOTER //
// ./components/appointments/add/appointment-add.controller.js